import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';

import { Stack, Typography } from '@mui/material';
import type { ICellEditorParams } from 'ag-grid-community';
import { useRecoilValue } from 'recoil';

import { usersState } from '../../../../entities/users';
import type { User } from '../../../../types';
import getFullName from '../../../../utils/getFullName';
import { TableSelect, UserAvatar } from '../../../base';

const Item = (user: User) => (
  <Stack component='span' direction='row' spacing={2} minWidth={0}>
    <UserAvatar user={user} size='s' />
    <Typography textOverflow='ellipsis' overflow='hidden'>
      {getFullName(user)}
    </Typography>
  </Stack>
);

export const ControlEditor = forwardRef((props: ICellEditorParams, ref) => {
  const cellData: User | undefined = props.value;
  const users = useRecoilValue(usersState);
  const [control, setControl] = useState<User | null>();

  const onSelect = (user: User | null) => {
    setControl(user);
  };

  useEffect(() => {
    if (control !== undefined) {
      props.stopEditing();
    }
  }, [control, props]);

  useImperativeHandle(ref, () => ({
    getValue() {
      return control !== undefined ? control : cellData;
    },
  }));

  return (
    <TableSelect data={users} value={cellData} onSelect={onSelect} itemRenderer={Item} getOptionLabel={getFullName} />
  );
});
